import { render, staticRenderFns } from "./item.move.vue?vue&type=template&id=0d7cb423&scoped=true&"
import script from "./item.move.vue?vue&type=script&lang=js&"
export * from "./item.move.vue?vue&type=script&lang=js&"
import style0 from "./item.move.vue?vue&type=style&index=0&id=0d7cb423&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7cb423",
  null
  
)

export default component.exports